export default __webpack_public_path__ + "static/media/normal_u31.fc63e776.png";